import { BoxProps, ButtonProps, ColorOptions, TextInputNewProps } from '@jfs/ui-new'

export const styles = () => {
  return {
    textInput: {
      type: 'body12',
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderColor: 'GREY_BORDER' as ColorOptions,
      labelPaddingBottom: 8,
      borderRadius: 4,
      fontFamily: 'jiotype-bold',
      labelColor: 'BLACK_21',
      labelFontSize: 12,
      fontSize: 11,
      selectionColor: 'BLUE',
    } as TextInputNewProps,
    duplicateButtonStyle: {
      type: 'custom',
      width: '100px',
      height: '34px',
      color: 'WHITE',
      hoverColor: 'TRANSAPRENT',
      underlayColor: 'TRANSAPRENT',
      borderWidth: '0.5px',
      borderColor: 'DISABLED_GREY',
      titleColor: 'TEXT_PRIMARY',
      borderRadius: '4px',
      textType: 'bodyMedium12',
      icon: 'DUPLICATE',
    } as ButtonProps,
    modal: {
      position: 'absolute',
      shadowOpacity: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      // ...shadowStyle,
      zIndex: 1,
      borderWidth: 1,
      borderColor: 'GRAY_BORDER',
    } as BoxProps,
    overlayStyle: {
      backgroundColor: 'TRANSPARENT',
      width: '100%',
      height: '100%',
    } as BoxProps,
    dropdownStyle: {
      position: 'absolute',
      flex: 1,
      shadowColor: 'BLACK_LIGHT',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.3,
      shadowRadius: 10,
      elevation: 2,
      borderRadius: 12,
      backgroundColor: 'BLUE',
      borderColor: 'SECONDARY_GREY',
    } as BoxProps,
    textinputStyle: {
      type: 'body12',
      borderColor: 'GREY_BORDER' as ColorOptions,
      labelPaddingBottom: 8,
      borderRadius: 4,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: 'BLACK_21',
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: 'BLUE',
      paddingHorizontal: 8,
      color: 'BLACK_21',
    },
  }
}
